
import each from 'lodash/each';
import debounce from 'lodash/debounce';

import { createStore, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from 'redux-thunk';

import { filterResults, createDataList, schema } from './data';
import { toggleFilterOption } from './components/CheckboxList';

import makeReducer from './makeReducer';

/**
 * Action Creators
 */

let deferredFiltering = (dispatch, getState) => {
    let state = getState();

    dispatch(filteredEntries(
        filterResults(state.entries, state.filter)
    ));
    dispatch(setLoading(false));
};

let slider_keys = {
    hoehenmeter: true,
    distance: true,
    duration: true,
};

let deferredFilteringSlow = debounce(deferredFiltering, 750);
let deferredFilteringFast = debounce(deferredFiltering, 200);


export function applyPrefilters(getState, dispatch) {
    let filters = getState().filter;
    let prefilters = getState().config.prefilters;

    if ( prefilters !== null ) {
        each(prefilters, (value, key) => {
            if ( !schema[key] ) return;
            if ( schema[key].type == "select" ) {
                each(value, option => {
                    value = toggleFilterOption(filters[key], option);
                })
            }
            dispatch(setFilter(key, value));
        })
    }
}

export const SET_FILTER = "SET_FILTER"
export function setFilter(key, value) {
    return (dispatch, getState) => {
        dispatch( { type: SET_FILTER, key, value } );
        if ( !getState().loading ) dispatch(setLoading(true));
        (slider_keys[key] ? deferredFilteringSlow : deferredFilteringFast)(dispatch, getState);
    }
}

export const RESET_FILTER = "RESET_FILTER"
export function resetFilter(key, value) {
    return (dispatch, getState) => {
        dispatch( { type: RESET_FILTER } );
        applyPrefilters(getState, dispatch);

        if ( !getState().loading ) dispatch(setLoading(true));
        deferredFilteringFast(dispatch, getState);
    }
}

export const SEARCH = "SEARCH"
export function search() { return { type: SEARCH } }

export const RECEIVED_ENTRIES = "RECEIVED_ENTRIES"
export function receivedEntries(entries) {return { type: RECEIVED_ENTRIES, entries } }

export const FILTERED_ENTRIES = "FILTERED_ENTRIES"
export function filteredEntries(entries) { return { type: FILTERED_ENTRIES, entries } }

export const TOGGLE_FAV = "TOGGLE_FAV"
export function toggleFav(id) { return { type: TOGGLE_FAV, id } }

export const SET_LOADING = "SET_LOADING"
export function setLoading(state) { return { type: SET_LOADING, state } }

export const SET_FAVORITES = "SET_FAVORITES"
export function setFavorites(favorites) { return { type: SET_FAVORITES, favorites } }

export const TOGGLE_FAVORITES_ONLY = "TOGGLE_FAVORITES_ONLY"
export function toggleFavoritesOnly() { return { type: TOGGLE_FAVORITES_ONLY,  } }

export const CONFIGURE = "CONFIGURE"
export function configure(config) { return { type: CONFIGURE, config } }

/**
 * Reducer
 */

let datalist_months = [
    {name: "beliebig", value: "", exclusive: true, checked: true},
    {name: "Mai", value: "Mai"},
    {name: "Juni", value: "Juni"},
    {name: "Juli", value: "Juli"},
    {name: "Aug", value: "August"},
    {name: "Sep", value: "September"},
    {name: "Okt", value: "Oktober"},
    {name: "Nov", value: "November"},
];


/* This is used as a global state. */
let defaultState = {
    config: {
        /* Allgemeine Slider (Höhe, Distanz, Dauer) */
        commonSliders: true,
        /* Farbslider (Erfahrung, ...) */
        colorSliders: true,
        /* Monats-Auswahl */
        monthsSelect: true,
        /* Kategorie-Auswahl */
        categorySelect: true,
        /* Pre-defined filters */
        prefilters: {
            //kategorie: ["3"],
        },
    },
    loading: true,
    favoritesOnly: false,
    filter: {
        search: "",
    },
    entries: [],
    filteredEntries: [],

    datalists: {},
    favorites: [],
    sliders: {
        hoehenmeter: {
            name: "hoehenmeter",
        },
        distance: {
            name: "distance",
        },
        duration: {
            name: "duration",
        },
    },
}


let rootReducer = makeReducer({

    default: () => ({
        ...defaultState,
    }),


    [SET_FILTER]: (state, action) => {
        if ( !action.key ) {
            throw new Error("SET_FILTER received without key: %o", action);
        }

        let filter = { ...state.filter };
        let new_value = action.value;
        if ( typeof action.value === "object" ) {
            new_value = new_value.filter(e => e !== null);
            if ( new_value.length === 0 ) {
                new_value = null;
            }
        }

        let sliders = { ...state.sliders };
        if ( sliders[action.key] ) {
            sliders[action.key] = {
                ... sliders[action.key],
                startValue: action.value[0],
                endValue: action.value[1],
            }
        }

        if ( new_value !== null ) {
            filter[action.key] = new_value;
        } else {
            delete filter[action.key];
        }

        return {
            ...state,
            filter: filter,
            sliders: sliders
        };
    },

    [RESET_FILTER]: (state, action) => {
        return { ...state, filter: defaultState.filter, sliders: defaultState.sliders };
    },

    [FILTERED_ENTRIES]: (state, action) => {
        return { ...state, filteredEntries: action.entries }
    },

    [RECEIVED_ENTRIES]: (state, action) => {
        console.log("[Alpininfo] Processing entries");

        let entries = action.entries;
        state = {
            ...state,
            sliders: { ...state.sliders },
            entries: action.entries,
            filteredEntries: action.entries,
        };


        /* Höhe */
        console.log("[Alpininfo] Processing Höhe");

        let hoehen_min = Math.min(... entries.map(e => e.min).filter(e => !!e));
        let hoehen_max = Math.max(... entries.map(e => e.max).filter(e => !!e));
        
        state.sliders.hoehenmeter = {
            ...state.sliders.hoehenmeter,
            startValue: hoehen_min,
            endValue: hoehen_max,
            minBound: hoehen_min,
            maxBound: hoehen_max,
        }
        defaultState.sliders.hoehenmeter = state.sliders.hoehenmeter;


        /* Distanz */
        console.log("[Alpininfo] Processing Distanz");

        let distances = entries.map(e => e.distance).filter(e => !!e);
        let distance_min = Math.min(... distances);
        let distance_max = Math.max(... distances);
        
        state.sliders.distance = {
            ...state.sliders.distance,
            startValue: distance_min,
            endValue: distance_max,
            minBound: distance_min,
            maxBound: distance_max,
        }
        defaultState.sliders.distance = state.sliders.distance;


        /* Dauer */
        console.log("[Alpininfo] Processing Dauer");

        let durations = entries.map(e => e.time).filter(e => !!e);
        let duration_min = Math.min(... durations);
        let duration_max = Math.max(... durations);

        state.sliders.time = {
            ...state.sliders.time,
            startValue: duration_min,
            endValue: duration_max,
            minBound: duration_min,
            maxBound: duration_max,
        }
        defaultState.sliders.time = state.sliders.time;


        /* Filter */
        console.log("[Alpininfo] Processing Filters");

        defaultState.filter.kategorie = state.filter.kategorie = createDataList(entries, "kategorie")
        defaultState.filter.status = state.filter.status = createDataList(entries, "status")
        defaultState.filter.jahreszeit = state.filter.jahreszeit = createDataList(entries, "jahreszeit")
        defaultState.filter.sonnigerweg = state.filter.sonnigerweg = createDataList(entries, "sonnigerweg")
        defaultState.filter.lage = state.filter.lage = createDataList(entries, "lage")
        defaultState.filter.months = state.filter.months = datalist_months

        console.log("[Alpininfo] Processing entries DONE!");
        return state;
    },

    [SET_LOADING]: (state, action) => {
        return { ...state, loading: action.state };
    },

    [TOGGLE_FAVORITES_ONLY]: (state, action) => {
        if ( state.favorites.length === 0 ) return state;
        return { ...state, favoritesOnly: !state.favoritesOnly };
    },

    [TOGGLE_FAV]: (state, action) => {
        let new_favorites = state.favorites.filter(f => {
            return f !== action.id;                
        });
        if ( new_favorites.length === state.favorites.length ) {
            new_favorites.push(action.id);
        }

        return {
            ...state,
            favorites: new_favorites,
            favoritesOnly: state.favoritesOnly && new_favorites.length > 0,
        }
    },

    [SET_FAVORITES]: (state, action) => {
        return {
            ...state,
            favorites: action.favorites,
        }
    },

    [CONFIGURE]: (state, action) => {
        return {
            ...state,
            config: { ...state.config, ...action.config }
        }
    },

})


let logReducer = reducer => (state, action) => {
    if ( console.group ) console.group();
    console.log("%c%s", "font-weight: bold; color: green", action.type);
    console.log("%cCurrentState: %c%o", "font-weight: bold; color: yellow", "font-weight: normal", state);
    console.log("%cAction: %c%o", "font-weight: bold; color: yellow", "font-weight: normal", action);

    let new_state;
    try {
        new_state = rootReducer(state, action);
    }
    catch ( e ) {
        console.error("Reducer error");
        console.exception(e);
        if ( console.groupEnd ) console.groupEnd();
        return state;
    }

    //console.log("%cNew State: %c%o", "font-weight: bold; color: yellow", "font-weight: normal", new_state);
    if ( console.groupEnd ) console.groupEnd();
    return new_state
}

console.log("[Alpininfo] Initialize Redux store");

let store = createStore(
    logReducer(rootReducer),
    applyMiddleware(ReduxThunk)
);
window.store = store;

export default store;



// WEBPACK FOOTER //
// ./store.js